import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';

export default class CardHeader extends Component {
  static propTypes = {
    author: PropTypes.any.isRequired,
    style: PropTypes.object,
    children: PropTypes.array,
    showMessageIcon: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
    posted_on: PropTypes.string,
    posted_on_words: PropTypes.string,
    twoLines: PropTypes.bool,
    useTimezone: PropTypes.string,
    isEvent: PropTypes.bool,
  };

  static defaultProps = {
    label: '',
    twoLines: false,
    showMessageIcon: false,
    posted_on: null,
    useTimezone: moment.tz.guess(),
    style: {},
    children: [],
    isEvent: false,
  };

  renderAvatar(author, extraClass = null) {
    return (
      <Avatar
        src={author.avatar}
        href={author.url}
        name={author.name}
        type={author.authorIsUser ? 'user' : 'company'}
        className={`Card-avatar ${extraClass}`}
        key={author.url}
      />
    );
  }

  renderContent(author) {
    let headline;

    if (author.job_title) {
      headline = (
        <span>
          {!this.props.twoLines && ', '}
          {author.job_title} at{' '}
          <a href={author.company_url} className="u-font-semibold">
            {author.company_name}
          </a>
        </span>
      );
    } else {
      headline = (
        <span>
          {!this.props.twoLines && ', '}
          {author.headline}
        </span>
      );
    }

    return (
      <div className="u-flex u-flex-col" key={`${this.props.url}-content`}>
        {this.props.isEvent && (
          <a className="u-text-lg u-font-bold u-mb-1 u-leading-4" href={this.props.url}>
            {this.props.title}
          </a>
        )}
        <div className="u-flex">
          {this.renderAvatar(author)}
          <div>
            {!this.props.isEvent && (
              <a className="u-text-lg u-font-semibold u-mb-2" href={this.props.url}>
                {this.props.title}
              </a>
            )}
            <div className="Card-author" key={author.url}>
              <div className="u-flex u-items-center">
                <div className="u-text-grey u-text-sm">
                  <a href={author.url} className="u-font-semibold">
                    {author.name}
                  </a>
                  {!this.props.twoLines && headline}
                </div>
                {this.props.showMessageIcon && author.authorIsUser && author.slug && (
                  <button
                    className="Button Button--tiny u-flex u-items-center"
                    data-connection={author.slug}>
                    <i className="Icon Icon-envelope" />
                  </button>
                )}
              </div>
              {this.props.twoLines && <div className="u-text-xs u-text-grey">{headline}</div>}
            </div>
            {this.renderLabel(this.props.label)}
          </div>
        </div>
      </div>
    );
  }

  renderContentMultipleAuthors(authors) {
    const avatars = authors.map((author) => this.renderAvatar(author, 'Avatar--facepile'));
    const names = authors.map((author, index) => (
      <a
        href={author.url}
        className={`u-whitespace-no-wrap u-font-semibold ${
          index < authors.length - 1 ? 'u-mr-1' : ''
        }`}
        key={author.url}>
        {`${author.name}${index < authors.length - 1 ? ',' : ''}`}
      </a>
    ));

    return (
      <div className="u-flex u-flex-col u-flex-1">
        {this.props.title && (
          <a className="u-text-lg u-font-semibold u-mb-1 u-leading-4" href={this.props.url}>
            {this.props.title}
          </a>
        )}
        <div className="lg:u-flex lg:u-flex-1 lg:u-items-center">
          <div
            className={`u-flex lg:u-h-10`}
            style={{ width: `${2 * authors.length + 0.5 + 1}rem` }}>
            <div className="lg:u-absolute">{avatars}</div>
          </div>
          <div className="Card-author u-mt-2 lg:u-mt-0">
            <div className="u-flex u-items-center u-flex-wrap u-text-sm">{names}</div>
            {this.renderLabel(this.props.label)}
          </div>
        </div>
      </div>
    );
  }

  renderLabel(label) {
    const labelCode = label.replace(/\s+/g, '-').toLowerCase();
    return (
      <div className="u-flex u-items-center u-text-xs">
        <div className={`u-font-semibold u-text-color-${labelCode}`}>{this.props.label}</div>
        {this.props.posted_on_words !== null && (
          <div className="u-text-grey u-ml-2" title={this.props.posted_on}>{this.props.posted_on_words}</div>
        )}
      </div>
    );
  }

  render() {
    let headerContent;
    if (this.props.author instanceof Array && this.props.author.length === 1) {
      headerContent = this.props.author.map((author) => this.renderContent(author));
    } else if (this.props.author instanceof Array) {
      headerContent = this.renderContentMultipleAuthors(this.props.author);
    } else {
      headerContent = this.renderContent(this.props.author);
    }

    return (
      <div className="CardHeader" style={this.props.style} key={this.props.url}>
        {this.props.children && <div className="Card-rightContent">{this.props.children}</div>}
        {headerContent}
      </div>
    );
  }
}
